/**
 * API URL prefix for the admin currency rates module.
 * Note: axios.defaults.baseURL already includes the "/api" segment,
 * so we only prepend the admin scope here.
 */
export const CURRENCY_RATES_API_PREFIX = "/admin/currency_rates";

/**
 * Endpoint paths exposed by the admin currency rates module.
 * List and create are served on the trailing slash server-side.
 */
export const CURRENCY_RATES_ENDPOINTS = {
    list: `${CURRENCY_RATES_API_PREFIX}/`,
    create: `${CURRENCY_RATES_API_PREFIX}/`,
    update: (rateId) => `${CURRENCY_RATES_API_PREFIX}/${rateId}`,
};

/** Spread charged to the payer when the admin leaves the margin empty. */
export const DEFAULT_MARGIN_PERCENT = "3";

/** Decimals the rate column stores server-side (Numeric(20, 8)). */
export const RATE_DECIMALS = 8;

/** Largest direct rate whose inverse still survives RATE_DECIMALS rounding. */
export const MAX_SEED_RATE = 10 ** RATE_DECIMALS;

/** Currencies offered in the direction pickers. */
export const KNOWN_CURRENCIES = ["EUR", "USD", "MGA"];

/**
 * Pairs the quick seed creates, mirroring scripts/seed_currency_rates.py.
 * Each entry also yields its reverse direction as a separate row.
 */
export const SEED_PAIRS = [
    { base: "EUR", quote: "MGA", field: "eurMga", label: "1 EUR en ariary" },
    { base: "USD", quote: "MGA", field: "usdMga", label: "1 USD en ariary" },
];

/** Indicative defaults, identical to the seeding script's own defaults. */
export const SEED_DEFAULTS = { eurMga: "5000", usdMga: "4600", margin: DEFAULT_MARGIN_PERCENT };
